import { useSelector } from 'react-redux';

import type { UIPublicAttribute } from 'src/adapters/storeToUI/adaptPublicAttributesToUI';
import { adaptPublicAttributesToUI } from 'src/adapters/storeToUI/adaptPublicAttributesToUI';
import { PRODUCT_CODE_TITLE } from 'src/components/layouts/PDP/copy';
import { selectProduct } from 'src/redux/product/selectors';

/**
 * View model for the "Product details" attribute list. Owns the product read and
 * the adapting, so the presentational list stays pure props.
 *
 * The product code is always appended as the last attribute, which is why the
 * layout can rely on the list never being empty.
 */
export type PublicAttributesViewModel = UIPublicAttribute[];

export const usePublicAttributesViewModel = (): PublicAttributesViewModel => {
  const product = useSelector(selectProduct);

  return [
    ...(product.publicAttributes ? adaptPublicAttributesToUI(product.publicAttributes) : []),
    { key: 'productCode', title: PRODUCT_CODE_TITLE, values: [String(product.code)] },
  ];
};
